/*
 * @Author: 张帮辉
 * @LastEditors: 赵泽文
 * @Date: 2022-03-15 15:08:23
 * @LastEditTime: 2022-05-26 11:42:00
 * @Description: 盘点单model
 */

import { getToday } from '@monorepo/utils';
import type {
  ICheckOrderModel,
  ICheckOrderStore,
} from '@monorepo/types/check/checkOrder/checkOrder.types';
import { tableUpdate } from '@monorepo/utils';

const initState: ICheckOrderStore = {
  query: {
    page: 1,
    pageSize: 50,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  isInit: true,
  auditNo: '',
  tableList: [],
  total: 0,
};

const checkOrderStore: ICheckOrderModel = {
  namespace: 'checkOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default checkOrderStore;
